import React from 'react';
import LegalLayout, { COMPANY } from './LegalLayout';

const About = () => (
  <LegalLayout title="About Elite Travo" eyebrow="Our story" lastUpdated="29 May 2026">
    <p data-testid="about-intro" className="text-lg font-medium">
      Elite Travo is a next-generation travel-tech platform that aggregates flights, hotels, buses,
      packages and more from leading global suppliers — and rebuilds the booking experience around
      transparency, speed and trust.
    </p>

    <h2>What we do</h2>
    <p>We connect to multiple inventory APIs (Hotelbeds, Redbus, IndTransact and counting), run a
      real-time comparison engine that de-duplicates listings and ranks them by price/latency/margin,
      then present a single, beautifully consistent storefront to the traveller. The result —
      better prices, no duplicate noise, and a checkout that feels effortless.</p>

    <h2>What makes us different</h2>
    <ul>
      <li><strong>Multi-supplier intelligence.</strong> We don't lock you into one supplier — we
        find the best one for each search.</li>
      <li><strong>Transparent pricing.</strong> Convenience fees, taxes and service charges are
        broken down upfront. No surprise add-ons at checkout.</li>
      <li><strong>Premium UX.</strong> Compact, content-rich, mobile-first. Designed by people who
        actually travel.</li>
      <li><strong>India-first, world-ready.</strong> Built for the Indian traveller — multi-currency,
        multi-language ready, GST-compliant.</li>
    </ul>

    <h2>Company details</h2>
    <ul>
      <li>Registered name: <strong>{COMPANY.name}</strong></li>
      <li>Address: {COMPANY.address}</li>
      <li>CIN: {COMPANY.cin}</li>
      <li>GSTIN: {COMPANY.gstin}</li>
      <li>Support email: <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
      <li>Phone: {COMPANY.phone}</li>
    </ul>
  </LegalLayout>
);

export default About;
